import { Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Card, List, Row } from '../home/charts/AbsenteeismRateCard.styles';

const LABEL_WIDTHS = ['55%', '40%', '65%', '35%', '50%', '45%'];

interface ISkeletonAbsenteeismRateCardProps {
  variant?: 'rank' | 'columns';
  rows?: number;
}

export const SkeletonAbsenteeismRateCard = ({ variant = 'rank', rows = 6 }: ISkeletonAbsenteeismRateCardProps) => {
  const { palette } = useTheme();

  return (
    <Card $isDark={palette.mode === 'dark'} aria-busy="true">
      <Skeleton variant="text" width="60%" height={22} />
      <Skeleton variant="text" width="80%" height={17} sx={{ mt: '4px' }} />

      {variant === 'rank' ? (
        <List>
          {Array.from({ length: rows }, (_, index) => (
            <Row key={index}>
              <Skeleton variant="text" width={LABEL_WIDTHS[index % LABEL_WIDTHS.length]} height={16} />
              <Skeleton variant="rectangular" width="100%" height={41} sx={{ borderRadius: '11px' }} />
            </Row>
          ))}
        </List>
      ) : (
        <Skeleton variant="rectangular" width="100%" height={240} sx={{ borderRadius: '4px' }} />
      )}
    </Card>
  );
};
